import React from 'react';

const clients = [
  { name: 'Globo.com', industry: 'Media & Technology', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Globo.com_logo.svg/200px-Globo.com_logo.svg.png' },
  { name: 'LuizaLabs', industry: 'E-commerce & Technology', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Magalu_-_novo_logo.png/200px-Magalu_-_novo_logo.png' },
];

interface ClientLogosProps {
  title?: string;
}

const ClientLogos: React.FC<ClientLogosProps> = ({ title = 'Trusted by leading companies' }) => {
  return (
    <div style={{
      padding: '48px 0',
      borderTop: '1px solid var(--border-color)',
      borderBottom: '1px solid var(--border-color)',
      background: 'var(--bg-secondary)',
      overflow: 'hidden',
    }}>
      <p style={{
        textAlign: 'center',
        fontSize: '0.78rem',
        fontWeight: 600,
        color: 'var(--text-muted)',
        textTransform: 'uppercase',
        letterSpacing: 2.5,
        marginBottom: 32,
      }}>
        {title}
      </p>

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 64,
        flexWrap: 'wrap',
      }}>
        {clients.map((client, i) => (
          <div
            key={i}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 16,
              padding: '16px 32px',
              background: 'white',
              borderRadius: 16,
              border: '1px solid var(--border-color)',
              boxShadow: '0 1px 3px rgba(0,0,0,0.03)',
              cursor: 'default',
              transition: 'all 0.3s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 16px rgba(37, 99, 235, 0.08)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.03)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <img
              src={client.logo}
              alt={client.name}
              style={{
                height: 36,
                width: 'auto',
                objectFit: 'contain',
                filter: 'grayscale(30%)',
                transition: 'filter 0.3s',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.filter = 'grayscale(0%)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.filter = 'grayscale(30%)'; }}
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
            <div>
              <div style={{ fontSize: '0.95rem', fontWeight: 700, color: 'var(--text-primary)' }}>
                {client.name}
              </div>
              <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', fontWeight: 500 }}>
                {client.industry}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientLogos;
